/**
 * The operational-day window — the original's module **`66818`**, exported as
 * `FS`, reproduced verbatim (§5.2 of `recovery-source/SPEC_staff-login.md`).
 *
 * ```js
 * function n() {
 *   let e, t;
 *   let r = new Date();
 *   r.getHours() >= 6
 *     ? ((e = new Date(r)).setHours(6, 0, 0, 0), (t = new Date(r)).setDate(t.getDate() + 1), t.setHours(6, 0, 0, 0))
 *     : ((e = new Date(r)).setDate(e.getDate() - 1), e.setHours(6, 0, 0, 0),
 *        (t = new Date(r)).setHours(6, 0, 0, 0));
 *   let n = new URLSearchParams();
 *   return (n.set("from_date", e.toISOString()), n.set("to_date", t.toISOString()), "?".concat(n.toString()));
 * }
 * ```
 *
 * A trading day runs **06:00 → 06:00**, not midnight to midnight, so an order
 * taken at 01:30 belongs to the shift that started the previous morning. Both
 * the X Report and the Staff Orders list count against it, which is why they
 * agree with the till at 2am.
 *
 * The boundary is computed in the BROWSER's timezone and only then serialised
 * to UTC, exactly as the original does — the shift is local to the store, and
 * the store is where the browser is.
 *
 * It returns the leading `?…` of a URL, including the question mark, because
 * every call site concatenates it directly onto a path.
 */
export const operationalDayQuery = (now: Date = new Date()): string => {
  let from: Date;
  let to: Date;
  if (now.getHours() >= 6) {
    from = new Date(now);
    from.setHours(6, 0, 0, 0);
    to = new Date(now);
    to.setDate(to.getDate() + 1);
    to.setHours(6, 0, 0, 0);
  } else {
    from = new Date(now);
    from.setDate(from.getDate() - 1);
    from.setHours(6, 0, 0, 0);
    to = new Date(now);
    to.setHours(6, 0, 0, 0);
  }
  const params = new URLSearchParams();
  params.set("from_date", from.toISOString());
  params.set("to_date", to.toISOString());
  return `?${params.toString()}`;
};

export default operationalDayQuery;
